(function() {
  'use strict';

  function autoSelectFirstVariant() {
    try {
      const variantRadios = document.querySelectorAll('input[type="radio"][name*="option"]');
      if (!variantRadios || variantRadios.length === 0) return;

      const optionNames = new Set();
      variantRadios.forEach(radio => {
        const name = radio.getAttribute('name');
        if (name) optionNames.add(name);
      });

      optionNames.forEach(optionName => {
        const optionRadios = document.querySelectorAll(`input[type="radio"][name="${optionName}"]`);
        const isAnySelected = Array.from(optionRadios).some(radio => radio.checked);
        if (!isAnySelected) {
          const firstAvailable = Array.from(optionRadios).find(radio => !radio.disabled);
          if (firstAvailable) {
            firstAvailable.checked = true;
            firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
            firstAvailable.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      });
    } catch (e) {
      console.debug('Auto-select variant:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoSelectFirstVariant);
  } else {
    autoSelectFirstVariant();
  }
})();
